import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlTabOrgaoSecretariaServidor = '/service/contabilidade/administracaoRH/'

class OrgaoSecretariaServidorService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getOrgaoSecretariaServidor() {
        return this.conex.get(urlTabOrgaoSecretariaServidor + 'retornaTodosOrgao/')
    }
}

export default OrgaoSecretariaServidorService
